import { createAction, props } from "@ngrx/store";
import { IPageCount, IPagination } from "src/app/shared/models/page.model";
import { APIResponse } from "src/app/core/models/api-response";
import { ICatalog, ICatalogFilter, ICatalogFilterRequest, INewCatalogDTO } from "../models/catalogs.models";
import { IProduct } from "../../produits/models/products.models";
import { IPriceBookSimple } from "../../pricebook/models/pricebook.model";
import { ICompanyFilterRequest, ICustomer } from "../../customers/models/customers.models";

// fetch all catalogs
export const FetchAllCatalogs = createAction(
  '[ Catalogs ] - FetchAllCatalogs',
);
export const FetchAllCatalogsSuccess = createAction(
  '[ Catalogs ] - FetchAllCatalogs Success ',
  props<{ catalogs: APIResponse<ICatalog> }>()
);
export const FetchAllCatalogsError = createAction(
  '[ Catalogs ] - FetchAllCatalogs Error',
);

// fetch catalogs
export const FetchCatalogs = createAction(
  '[ Catalogs ] - FetchCatalogs',
  props<{
    page: IPageCount,
    filter?: ICatalogFilterRequest | undefined
    key?: string | undefined
    sort_by?: string | undefined
    sort_mode?: string | undefined
  }>()
);
export const FetchCatalogsSuccess = createAction(
  '[ Catalogs ] - FetchCatalogs Success ',
  props<{ catalogs: APIResponse<ICatalog> }>()
);
export const FetchCatalogsError = createAction(
  '[ Catalogs ] - FetchCatalogs Error',
);

// clear catalog cache
export const ClearCatalog = createAction(
  '[ Catalogs ] - ClearCatalog',
);

// get catalog by id
export const GetCatalogById = createAction(
  '[ Catalogs ] - GetCatalogById',
  props<{ id: number, simplified?: boolean | false }>()
);
export const GetCatalogByIdSuccess = createAction(
  '[ Catalogs ] - GetCatalogById Success ',
  props<{ catalog: ICatalog}>()
);
export const GetCatalogByIdError = createAction(
  '[ Catalogs ] - GetCatalogById Error',
);

// get catalog by id
export const GetCatalogProducts = createAction(
  '[ Catalogs ] - GetCatalogProducts',
  props<{ id: number; page?: number; limit?: number; simplified?: boolean | false }>()
);
export const GetCatalogProductsSuccess = createAction(
  '[ Catalogs ] - GetCatalogProducts Success ',
  props<{ products: IProduct[]; metadata?: IPagination }>()
);
export const GetCatalogProductsError = createAction(
  '[ Catalogs ] - GetCatalogProducts Error',
);

// load more catalog products (append mode for pagination)
export const LoadMoreCatalogProducts = createAction(
  '[ Catalogs ] - LoadMoreCatalogProducts',
  props<{ id: number; page: number; limit?: number }>()
);
export const LoadMoreCatalogProductsSuccess = createAction(
  '[ Catalogs ] - LoadMoreCatalogProducts Success',
  props<{ products: IProduct[]; metadata?: IPagination }>()
);

// add catalogs
export const AddCatalog = createAction(
  '[ Catalogs ] - AddCatalog',
  props<{ catalog: Omit<ICatalog, 'id'>  }>()
);
export const AddCatalogSuccess = createAction(
  '[ Catalogs ] - AddCatalog Success ',
  props<{ catalog: ICatalog | undefined }>()
);
export const AddCatalogError = createAction(
  '[ Catalogs ] - AddCatalog Error',
);

// add agent type catalog
export const AddAgentCatalog = createAction(
  '[ Catalogs ] - AddAgentCatalog',
  props<{ catalog: Partial<INewCatalogDTO>  }>()
);
export const AddAgentCatalogSuccess = createAction(
  '[ Catalogs ] - AddAgentCatalog Success ',
  props<{ catalog: any | undefined }>()
);
export const AddAgentCatalogError = createAction(
  '[ Catalogs ] - AddAgentCatalog Error',
);

// add agent type catalog
export const UpdateAgentCatalog = createAction(
  '[ Catalogs ] - UpdateAgentCatalog',
  props<{ id: number; catalog: Partial<INewCatalogDTO>  }>()
);
export const UpdateAgentCatalogSuccess = createAction(
  '[ Catalogs ] - UpdateAgentCatalog Success ',
  props<{ catalog: any | undefined }>()
);
export const UpdateAgentCatalogError = createAction(
  '[ Catalogs ] - UpdateAgentCatalog Error',
);

//update catalogs
export const UpdateCatalog = createAction(
  '[ Catalogs ] - UpdateCatalog',
  props<{ id: number, catalog: Omit<ICatalog, 'id'> }>()
);
export const UpdateCatalogSuccess = createAction(
  '[ Catalogs ] - UpdateCatalog Success ',
  props<{ catalog: ICatalog | undefined }>()
);
export const UpdateCatalogError = createAction(
  '[ Catalogs ] - UpdateCatalog Error',
);

//Delete catalogs
export const DeleteCatalog = createAction(
  '[ Catalogs ] - DeleteCatalog',
  props<{ id: number }>()
);
export const DeleteCatalogSuccess = createAction(
  '[ Catalogs ] - DeleteCatalog Success ',
);
export const DeleteCatalogError = createAction(
  '[ Catalogs ] - DeleteCatalog Error',
);

// Delete multiple catalogs
export const DeleteCatalogs = createAction(
  '[ Catalogs ] - DeleteCatalog',
  props<{ pricelist_ids: number[] }>()
);
export const DeleteCatalogsSuccess = createAction(
  '[ Catalogs ] - DeleteCatalog Success ',
);
export const DeleteCatalogsError = createAction(
  '[ Catalogs ] - DeleteCatalog Error',
);

// export catalogs
export const ExportCatalogs = createAction(
  '[ Catalogs ] - ExportCatalogs',
  props<{ filter: ICatalogFilterRequest, key: string }>()
);
export const ExportCatalogsSuccess = createAction(
  '[ Catalogs ] - ExportCatalogs Success ',
);
export const ExportCatalogsError = createAction(
  '[ Catalogs ] - ExportCatalogs Error',
);

// download catalog
export const DownloadCatalog = createAction(
  '[ Catalogs ] - DownloadCatalog',
  props<{ id: number }>()
);
export const DownloadCatalogSuccess = createAction(
  '[ Catalogs ] - DownloadCatalog Success ',
);
export const DownloadCatalogError = createAction(
  '[ Catalogs ] - DownloadCatalog Error',
);

// export catalogs
export const DownloadCatalogs = createAction(
  '[ Catalogs ] - DownloadCatalogs',
  props<{ page: IPageCount,
    filter?: ICatalogFilterRequest | undefined
    key?: string | undefined
    sort_by?: string | undefined
    sort_mode?: string | undefined 
    pricelist_ids?: number[] | [] | undefined}>()
);
export const DownloadCatalogsSuccess = createAction(
  '[ Catalogs ] - ExportCatalogs Success ',
);
export const DownloadCatalogsError = createAction(
  '[ Catalogs ] - ExportCatalogs Error',
);


// loader actions
export const SetCatalogLoader = createAction(
  '[ Catalogs ] - StartLoading',
  props<{ isLoading: boolean }>()
);

// Company catalogs by id
export const FetchAllCompanyCatalogsById = createAction(
  '[ Catalogs ] - FetchAllCompanyCatalogsById',
  props<{ id: number }>()
);
export const FetchAllCompanyCatalogsByIdSuccess = createAction(
  '[ Catalogs ] - FetchAllCompanyCatalogsById Success ',
  props<{ companyCatalogsById: ICatalog[] }>()
);
export const FetchAllCompanyCatalogsByIdError = createAction(
  '[ Catalogs ] - FetchAllCompanyCatalogsById Error',
);

// Company catalog products by id
export const GetProductsCatalogCompanyById = createAction(
  '[ Catalogs ] - GetProductsCatalogCompanyById',
  props<{ locationId: number, catalogId: number, orderId?: number, page?: number, limit?: number}>()
);
export const GetProductsCatalogCompanyByIddSuccess = createAction(
  '[ Catalogs ] - GetProductsCatalogCompanyByIdd Success ',
  props<{ products: IProduct[]}>()
);
export const GetProductsCatalogCompanyByIddError = createAction(
  '[ Catalogs ] - GetProductsCatalogCompanyByIdd Error',
);
export const SetSearchCatalogsLoader = createAction(
  '[ Loader ] - SearchLoader',
  props<{ isLoading: boolean }>()
);
// Filters
export const SetCatalogsFilter = createAction(
  '[ Filters ] - SetCatalogsFilter',
  props<{ keyword: string, advanced: ICatalogFilter | null }>()
);
// search
export const SetCatalogsSearch = createAction(
  '[ Search ] - SetCatalogsSearch',
  props<{ search: string }>()
);

// Share catalog
export const ShareCatalog = createAction(
  '[ Catalogs ] - ShareCatalog',
  props<{ catalogId: number, data: { locations_ids: number[], attach_excel: boolean } }>()
);
export const ShareCatalogSuccess = createAction(
  '[ Catalogs ] - ShareCatalog Success',
  props<{ notifiedCount: number }>()
);
export const ShareCatalogError = createAction(
  '[ Catalogs ] - ShareCatalog Error',
  props<{ error: any }>()
);

// Pricebook actions
export const AddPromotionToCatalog = createAction(
  '[ Catalogs ] - AddPricebookToCatalog',
  props<{ promotion: IPriceBookSimple }>()
);

// Get catalog audience companies (paginated)
export const GetCatalogAudience = createAction(
  '[ Catalogs ] - GetCatalogAudience',
  props<{
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortMode?: 'asc' | 'desc';
    pricelistId?: number;
    filters?: ICompanyFilterRequest;
  }>()
);
export const GetCatalogAudienceSuccess = createAction(
  '[ Catalogs ] - GetCatalogAudience Success',
  props<{ companies: ICustomer[]; metadata?: IPagination }>()
);
export const GetCatalogAudienceError = createAction(
  '[ Catalogs ] - GetCatalogAudience Error'
);

// Load more catalog audience companies (append mode for pagination)
export const LoadMoreCatalogAudience = createAction(
  '[ Catalogs ] - LoadMoreCatalogAudience',
  props<{
    page: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortMode?: 'asc' | 'desc';
    pricelistId?: number;
    filters?: ICompanyFilterRequest;
  }>()
);
export const LoadMoreCatalogAudienceSuccess = createAction(
  '[ Catalogs ] - LoadMoreCatalogAudience Success',
  props<{ companies: ICustomer[]; metadata?: IPagination }>()
);

// Clear catalog audience (reset state)
export const ClearCatalogAudience = createAction(
  '[ Catalogs ] - ClearCatalogAudience'
);

// ============================================
// Available Companies for Selection (All companies list)
// Used in agent-companies-list component for selecting companies to assign
// ============================================

// Get available companies for selection (paginated)
export const GetAvailableCompanies = createAction(
  '[ Catalogs ] - GetAvailableCompanies',
  props<{
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortMode?: 'asc' | 'desc';
    subsidiary_id?: number;
    filters?: ICompanyFilterRequest;
  }>()
);
export const GetAvailableCompaniesSuccess = createAction(
  '[ Catalogs ] - GetAvailableCompanies Success',
  props<{ companies: ICustomer[]; metadata?: IPagination }>()
);
export const GetAvailableCompaniesError = createAction(
  '[ Catalogs ] - GetAvailableCompanies Error'
);

// Load more available companies (append mode for pagination)
export const LoadMoreAvailableCompanies = createAction(
  '[ Catalogs ] - LoadMoreAvailableCompanies',
  props<{
    page: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortMode?: 'asc' | 'desc';
    subsidiary_id?: number;
    filters?: ICompanyFilterRequest;
  }>()
);
export const LoadMoreAvailableCompaniesSuccess = createAction(
  '[ Catalogs ] - LoadMoreAvailableCompanies Success',
  props<{ companies: ICustomer[]; metadata?: IPagination }>()
);

// Clear available companies (reset state)
export const ClearAvailableCompanies = createAction(
  '[ Catalogs ] - ClearAvailableCompanies'
);
